import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editorFailedToLoad: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-failed-to-load',
		defaultMessage: 'We couldn’t load the editor. Save your changes, refresh, and try again.',
		description: 'Displayed if the text editor fails to load.',
	},
	editorContextErrorTitle: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-title',
		defaultMessage: "We couldn't save your changes",
		description: 'Title for an error while interacting with the text editor',
	},
	editorContextErrorMessageToRefreshPage: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-message-to-refresh-page',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Instructions to refresh the page after an error while interacting with the text editor',
	},
	editorContextErrorMessageToReloadEditor: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-message-to-reload-editor',
		defaultMessage: 'Reload the editor and try again.',
		description:
			'Instructions to reload the editor after an error while interacting with the text editor',
	},
	editorContextErrorAction: {
		id: 'project-settings-apps-issue-type-page-product-features.common.field-active.field-configuration.multiline.async-editor.editor-context-error-action',
		defaultMessage: 'Try again',
		description:
			'Button label to reload the editor after an error while interacting with the text editor',
	},
});
